import { action } from 'satcheljs/lib/legacy';
import { getStore } from '../store/Store';
import { Module, SubRoute, SubRouteOption } from 'mini-common-schema';

/**
 * Switch between different Modules and sub routes
 */
export default action('switchModule')(function switchModule(
    module: Module,
    subRoute?: SubRoute,
    subRouteOption?: SubRouteOption
) {
    const store = getStore();

    store.mailModule.selectedModule = module;
    store.mailModule.selectedSubRoute = subRoute;
    store.mailModule.selectedSubRouteOption = subRouteOption;
});
